"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Credentials = void 0;
var constants_1 = require("../constants");
var api_1 = require("../info-auth-api/api");
var model_1 = require("../model");
var createSession = function (storage) {
    var tokens = getTokensFromStorage(storage);
    if (tokens.id && tokens.access) {
        return new model_1.UserSession(new model_1.JWTToken(tokens.id), new model_1.JWTToken(tokens.access), tokens.language ? tokens.language : 'en');
    }
};
var getTokensFromStorage = function (storage) {
    return {
        id: storage.getItem(constants_1.ID_TOKEN_KEY),
        access: storage.getItem(constants_1.ACCESS_TOKEN_KEY),
        refresh: storage.getItem(constants_1.REFRESH_TOKEN_KEY),
        language: storage.getItem('language')
    };
};
var setTokensToStorage = function (token, storage) {
    storage.clear();
    storage.setItem(constants_1.ID_TOKEN_KEY, token.id ? token.id : null);
    storage.setItem(constants_1.ACCESS_TOKEN_KEY, token.access ? token.access : null);
    storage.setItem(constants_1.REFRESH_TOKEN_KEY, token.refresh ? token.refresh : null);
    storage.setItem('language', token.language ? token.language : 'en');
};
var Credentials = /** @class */ (function () {
    function Credentials(storage, config) {
        this.storage = storage;
        this.config = config;
    }
    Credentials.prototype.setCredential = function (tokens) {
        setTokensToStorage(tokens, this.storage);
        this.userSession = createSession(this.storage);
    };
    Credentials.prototype.removeCredential = function () {
        this.storage.removeItem(constants_1.ID_TOKEN_KEY);
        this.storage.removeItem(constants_1.ACCESS_TOKEN_KEY);
        this.storage.removeItem(constants_1.REFRESH_TOKEN_KEY);
        this.userSession = undefined;
    };
    Credentials.prototype.isExpired = function () {
        return !(this.userSession && this.userSession.isValid());
    };
    Credentials.prototype.getSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // session is not defined try to create it from storage
                        if (!this.userSession) {
                            this.userSession = createSession(this.storage);
                        }
                        if (!(this.userSession && this.userSession.isValid())) return [3 /*break*/, 1];
                        return [2 /*return*/, this.userSession];
                    case 1: return [4 /*yield*/, this.refresh()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.userSession];
                }
            });
        });
    };
    Credentials.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, postData, userDetails, refreshTokens, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        tokens = getTokensFromStorage(this.storage);
                        if (!tokens.refresh) return [3 /*break*/, 2];
                        postData = {
                            token: tokens.refresh
                        };
                        return [4 /*yield*/, api_1.default.refresh(this.config.provider.infoauth.redirectUri, postData)];
                    case 1:
                        userDetails = _a.sent();
                        refreshTokens = {
                            id: userDetails.id_token,
                            access: userDetails.access_token,
                            refresh: userDetails.refresh_token
                        };
                        this.setCredential(refreshTokens);
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.userSession = undefined;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Credentials;
}());
exports.Credentials = Credentials;
//# sourceMappingURL=info.credentials.js.map